/**
 * HeroPhotoLayer — absolute-positioned photo + overlay for hero sections.
 *
 * Usage: add position:'relative' to the hero container, render this as
 * first child, wrap existing text content with position:'relative', zIndex:1.
 *
 * Props:
 *   heroImage   — HeroImageResult dict from backend (optional)
 *   isMobile    — use mobile_url instead of desktop_url
 *   dominantColor — fallback color if no image available
 */
import React, { useState } from 'react';

export function HeroPhotoLayer({ heroImage, isMobile = false, dominantColor }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const base = dominantColor || heroImage?.dominant_color || '#0c1220';
  const url = isMobile
    ? (heroImage?.mobile_url || heroImage?.desktop_url || '')
    : (heroImage?.desktop_url || heroImage?.mobile_url || '');

  if (!url || error) return null;

  return (
    <>
      <img
        src={url}
        alt={heroImage?.alt_text || ''}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        style={{
          position:       'absolute',
          inset:          0,
          width:          '100%',
          height:         '100%',
          objectFit:      'cover',
          objectPosition: 'center',
          opacity:        loaded ? 1 : 0,
          transition:     'opacity 0.4s ease',
          display:        'block',
          pointerEvents:  'none',
        }}
      />
      <div style={{
        position:      'absolute',
        inset:         0,
        background:    isMobile
          ? `linear-gradient(180deg, ${base}cc 0%, ${base}e0 60%, ${base}f5 100%)`
          : `linear-gradient(90deg, ${base}e0 0%, ${base}c0 45%, ${base}60 100%)`,
        pointerEvents: 'none',
      }} />
      {heroImage?.photographer && heroImage?.provider !== 'local' && (
        <div style={{
          position:      'absolute',
          bottom:        5,
          right:         8,
          fontSize:      9,
          color:         'rgba(255,255,255,0.3)',
          lineHeight:    1,
          pointerEvents: 'none',
          userSelect:    'none',
          zIndex:        2,
        }}>
          {heroImage.provider === 'unsplash'
            ? `${heroImage.photographer} / Unsplash`
            : heroImage.photographer || 'Wikimedia Commons'}
        </div>
      )}
    </>
  );
}

export default HeroPhotoLayer;
